import { useMemo, useState } from 'react'
import ReactDOM from "react-dom";
import { useSelector } from "react-redux";

import Button from '../../../common/Button'
import Backdrop from "../../../common/modal/Backdrop";
import Modal from "../../../common/Modal";
import AddNotes from "./AddNotes";
import NotesFilters from "./NotesFilters";
import { canSeeCaseNotesTab, filterNotesByPermission } from "../../../../lib/notesPermissions";
import { caseNotesForViewer, isDeletedRecord } from "../../../../lib/noteDelete";

import classes from './NotesControls.module.css'
import checkboxClasses from '../../../common/interactive/CheckboxCell.module.css'

const NotesControls = ({ showDeleted, onShowDeletedChange }) => {
    const [isModalOpened, setisModalOpened] = useState(false)

    const openModalHandler = () => {
        setisModalOpened(true)
    }

    const closeModalHandler = () => {
        setisModalOpened(false)
    }

    const activeCase = useSelector(state => state.case.activeCase)
    const editPermissions = useSelector(state => state.permissions.editPermissions)
    const userPermissions = useSelector(state => state.user.user?.permissions)
    const permittedNotes = useMemo(
        () => filterNotesByPermission(activeCase?.notes, editPermissions),
        [activeCase?.notes, editPermissions]
    )
    const canSeeNotesTab = useMemo(
        () => canSeeCaseNotesTab(userPermissions, editPermissions, activeCase),
        [userPermissions, editPermissions, activeCase]
    )
    const hasDeleted = useMemo(() => {
        const visibleToViewer = caseNotesForViewer(permittedNotes, canSeeNotesTab)
        return Array.isArray(visibleToViewer) && visibleToViewer.some(isDeletedRecord)
    }, [permittedNotes, canSeeNotesTab])
    
    return <>
        <div className={classes.controls}>
            {activeCase && permittedNotes && permittedNotes.length > 0 && <NotesFilters />}
            {hasDeleted && (
                <label className={`${checkboxClasses.checkbox_field} ${checkboxClasses.reverse} ${classes.show_deleted}`}>
                    <span>Show deleted</span>
                    <input
                        type="checkbox"
                        className={checkboxClasses.checkbox}
                        checked={Boolean(showDeleted)}
                        onChange={(event) => onShowDeletedChange(event.target.checked)}
                    />
                </label>
            )}
            {activeCase && <Button click={openModalHandler}>
                <i className="ti ti-square-plus"></i>Add note/task
            </Button>}
        </div>

        {isModalOpened && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeModalHandler} noBlur />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <AddNotes data={activeCase} closeModal={closeModalHandler} typeSelected={'Attorney'}/>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    </>
}

export default NotesControls
